export enum StorageMap {
	Token = "cp_tk",
	ScoreRecentVisit = "cp_rv",
	Score = "cp_sc",
	Objectives = "cp_ob",
	Historic = "cp_ht",
	SortingDebts = "cp_sd",
	DashTab = "cp_dt",
	NegativeDebts = "cp_nd",
	CpfLookout = "cp_cl",
	SatisfactionSurvey = "cp_ss",
	SatisfactionObjectivesSurvey = "cp_so",
	ScoreAnimation = "cp_sa",
	ScorePromotion = "cp_sp",
}
